/* Atlas home product card (ported from ac-cat-v2 home-card.js): colour swatches, quick add.
   Delegated so it works for cards in every tab and after section reloads. */
(function () {
  if (window.__atlasHomeCardInit) return;
  window.__atlasHomeCardInit = true;

  function setColor(card, idx) {
    card.dataset.ci = String(idx);
    card.querySelectorAll('[data-ci].home-card__imgset, [data-ci].home-card__sizes').forEach(function (el) {
      el.hidden = el.getAttribute('data-ci') !== String(idx);
    });
    card.querySelectorAll('[data-swatch]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-swatch') === String(idx));
    });
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('[data-swatch]');
    if (swatch) {
      var c1 = swatch.closest('[data-home-card]');
      if (c1) { e.preventDefault(); setColor(c1, parseInt(swatch.getAttribute('data-swatch'), 10) || 0); }
      return;
    }
    var plus = e.target.closest('[data-plus]');
    if (plus) {
      var c2 = plus.closest('[data-home-card]');
      if (c2) { e.preventDefault(); e.stopPropagation(); c2.classList.add('is-q'); }
      return;
    }
    var btn = e.target.closest('.home-card__size');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-oos') || btn.getAttribute('aria-disabled') === 'true') return;
    var card = btn.closest('[data-home-card]');
    if (!card || card.classList.contains('is-busy')) return;
    var group = btn.closest('[data-color]');
    var color = group ? group.getAttribute('data-color') : '';
    var meta = [card.dataset.title, color && color !== '1' ? color : '', btn.getAttribute('data-size')].filter(Boolean).join(' · ');
    card.classList.add('is-busy');
    btn.classList.add('is-loading');
    window.Atlas.cart.add([{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }], {
      open: false,
      toast: { img: btn.getAttribute('data-img') || '', meta: meta }
    }).then(function () {
      card.classList.remove('is-q');
      card.classList.add('is-added');
      var pick = card.querySelector('[data-pick]'), done = card.querySelector('[data-done]');
      if (pick) pick.hidden = true;
      if (done) done.hidden = false;
      setTimeout(function () {
        card.classList.remove('is-added');
        if (pick) pick.hidden = false;
        if (done) done.hidden = true;
      }, 1600);
    }).catch(function (err) {
      if (window.console) console.warn('Quick add failed', err);
    }).then(function () { card.classList.remove('is-busy'); btn.classList.remove('is-loading'); });
  });

  /* Pointer leaves the card: close the mobile quick-add panel (prototype behaviour) */
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('[data-home-card]');
    if (!card || !card.classList.contains('is-q')) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return;
    card.classList.remove('is-q');
  });
})();
